import styles from "./svgs.module.scss";

function DeliveryShippingIcon(props: any) {
  const { width = 35, height = 35, classNames = "" } = props;
  return (
    <i className={`${styles.icon} ${styles.delivery_icons} ${styles.delivery_shipping} ${classNames}`} style={{ width, height }} />
  );
}

export default DeliveryShippingIcon;
